import * as moment from "moment";
import DateUtils from "../../../utils/DateUtils";
import CurrencyHelper from "../../../helper/CurrencyHelper";
import {isDefined} from "../../../utils/Utils";

export enum AccountingCommonField {
	DUE_DATE = "DUE_DATE",
	INVOICE_DATE = "INVOICE_DATE",
	CUSTOMER_DISPLAY_NAME = "CUSTOMER_DISPLAY_NAME",
	PARTNER_PARTS_MARGIN = "PARTNER_PARTS_MARGIN",
	HIBER_PARTS_MARGIN = "HIBER_PARTS_MARGIN",
	LABOUR = "LABOUR",
	HIBER_FEE = "HIBER_FEE",
	DESCRIPTION = "DESCRIPTION",
	QUANTITY = "QUANTITY",
	UNIT_PRICE = "UNIT_PRICE",
	ACCOUNT = "ACCOUNT",
	TAX_RATE = "TAX_RATE",
	AMOUNT = "AMOUNT",
	SUBTOTAL = "SUBTOTAL",
	TAX = "TAX",
	TOTAL = "TOTAL"
}

export const AccountingCommonFieldLabel: { [key: string]: string } = {
	[AccountingCommonField.DUE_DATE]: "Due date",
	[AccountingCommonField.INVOICE_DATE]: "Invoice date",
	[AccountingCommonField.CUSTOMER_DISPLAY_NAME]: "Customer display name",
	[AccountingCommonField.PARTNER_PARTS_MARGIN]: "Partner parts margin",
	[AccountingCommonField.HIBER_PARTS_MARGIN]: "Hiber service charge",
	[AccountingCommonField.LABOUR]: "Labour",
	[AccountingCommonField.HIBER_FEE]: "Hiber Parts",
	[AccountingCommonField.DESCRIPTION]: "Description",
	[AccountingCommonField.UNIT_PRICE]: "Unit price",
	[AccountingCommonField.QUANTITY]: "Quantity",
	[AccountingCommonField.ACCOUNT]: "Account",
	[AccountingCommonField.TAX_RATE]: "Tax rate",
	[AccountingCommonField.AMOUNT]: "Amount",
	[AccountingCommonField.SUBTOTAL]: "Subtotal",
	[AccountingCommonField.TAX]: "Tax",
	[AccountingCommonField.TOTAL]: "Total"
};

const DateFields: { [key: string]: boolean } = {
	[AccountingCommonField.INVOICE_DATE]: true,
	[AccountingCommonField.DUE_DATE]: true
};

const CurrencyFields: { [key: string]: boolean } = {
	[AccountingCommonField.HIBER_FEE]: true,
	[AccountingCommonField.HIBER_PARTS_MARGIN]: true,
	[AccountingCommonField.LABOUR]: true,
	[AccountingCommonField.PARTNER_PARTS_MARGIN]: true,
	[AccountingCommonField.UNIT_PRICE]: true,
	[AccountingCommonField.AMOUNT]: true,
	[AccountingCommonField.SUBTOTAL]: true,
	[AccountingCommonField.TAX]: true,
	[AccountingCommonField.TOTAL]: true
};

const PercentageFields: { [key: string]: boolean } = {
	[AccountingCommonField.TAX_RATE]: true
};

export enum AccountingCommonFieldDifferenceType {
	NEW = "NEW",
	DELETED = "DELETED",
	CHANGED = "CHANGED"
}

export const AccountingCommonFieldDifferenceLabel: { [key: string]: string } = {
	[AccountingCommonFieldDifferenceType.NEW]: "added",
	[AccountingCommonFieldDifferenceType.DELETED]: "deleted",
	[AccountingCommonFieldDifferenceType.CHANGED]: "changed"
};

export class AccountingCommonUpdatedEventHelper {

	static formatValue(value: string | number, fieldName: string) {
		let formattedValue: string;
		if (DateFields[fieldName]) {
			formattedValue = isDefined(value) ? moment(value).format(DateUtils.DATE_FORMAT) : "none";
		}
		else if (CurrencyFields[fieldName]) {
			formattedValue = isDefined(value) ? CurrencyHelper.toCurrency(Number(value)) : "none";
		}
		else if (PercentageFields[fieldName]) {
			formattedValue = isDefined(value) ? `${value as string}%` : "none";
		}
		else {
			formattedValue = isDefined(value) ? value as string : "none";
		}
		return formattedValue;
	}

	static formatChange(fieldName: string, oldValue: string, newValue: string, diffType: AccountingCommonFieldDifferenceType) {
		switch (diffType) {
			case AccountingCommonFieldDifferenceType.NEW:
				return `${AccountingCommonFieldLabel[fieldName]}: ${newValue}`;
			case AccountingCommonFieldDifferenceType.DELETED:
				return `${AccountingCommonFieldLabel[fieldName]}: ${oldValue}`;
			case AccountingCommonFieldDifferenceType.CHANGED:
				return `${AccountingCommonFieldLabel[fieldName]}: ${oldValue} → ${newValue}`;
		}
	}

	static formatDescription(description: string, diffType: AccountingCommonFieldDifferenceType) {
		return `${description} ${AccountingCommonFieldDifferenceLabel[diffType]}:`
	}
}
